import React from 'react';
import '../components/grammar-page.css';
import { FaBookOpen, FaLightbulb } from 'react-icons/fa';

const PassiveReportingExplanation = () => {
  return (
    <div className="grammar-explanation">
      <h2><FaBookOpen /> Passive Reporting Verbs and "Be Supposed To"</h2>
      <p>
        When we talk about general beliefs, traditions, and expectations, we often use passive
        structures to avoid saying "people say" or "everyone knows".
      </p>

      <div className="grammar-explanation-grid">
        <div className="example-block">
          <h3><FaLightbulb /> Passive reporting verbs</h3>
          <ul>
            <li><strong>It + passive verb + that…</strong></li>
            <li><em>It is said that food tastes better when shared.</em></li>
            <li><em>It is believed that salt protects against evil.</em></li>
          </ul>
        </div>

        <div className="example-block">
          <h3><FaLightbulb /> Subject + passive verb + to-infinitive</h3>
          <ul>
            <li>Used for reputation or general opinion.</li>
            <li><em>Red wine is thought to be good for the heart.</em></li>
            <li><em>This recipe is said to be 100 years old.</em></li>
          </ul>
        </div>
      </div>

      <div className="example-block">
        <h3><FaLightbulb /> Be supposed to</h3>
        <ul>
          <li><strong>Expectation or social rule:</strong> <em>You are supposed to leave a small amount of food on your plate in some cultures.</em></li>
          <li><strong>Rumor or reputation:</strong> <em>That new street food stall is supposed to be the best in the city.</em></li>
        </ul>
      </div>

      <h3><FaLightbulb /> Summary</h3>
      <div className="grammar-flex-table">
        {[
          ['Structure', 'Meaning', 'Example'],
          ['It is believed that…', 'General belief', 'It is believed that salt protects against evil.'],
          ['Subject + is said to…', 'Reputation', 'This recipe is said to be 100 years old.'],
          ['Be supposed to + verb', 'Social rule', 'Are we supposed to tip the waiter here?'],
        ].map(([structure, meaning, example], index) => (
          <div key={index} className={`grammar-flex-row${index === 0 ? ' header' : ''}`}>
            <div className="grammar-cell">{structure}</div>
            <div className="grammar-cell">{meaning}</div>
            <div className="grammar-cell">{example}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PassiveReportingExplanation;
